require('../../../modules/es.array.for-each');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').forEach;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/array/virtual/for-each.js
// module id = 975
// module chunks = 0